import React from "react";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import withMotion from "../../../Utils/withMotion";

//Panels
// import PageNotFound from "../../../404";
import HowToChooseTheRightPaverColor, {
  HowToChooseTheRightPaverColorData,
} from "./Pages/ChooseTheRightPaverColor";
import RemovingOilStains, {
  RemovingOilStainsData,
} from "./Pages/RemovingOilStains";
import InstallingPaversConcrete, {
  InstallingPaversConcreteData,
} from "./Pages/InstallingPaversConcrete";
import JointSand, { JointSandData } from "./Pages/JointSand";
import Sealer, { SealerData } from "./Pages/Sealer";
import KnowYourPaver, { KnowYourPaverData } from "./Pages/KnowYourPaver";
import PatioEdging, { PatioEdgingData } from "./Pages/PatioEdging";
import DrivewayComparing, {
  DrivewayComparingData,
} from "./Pages/DrivewayComparing";
import HillsideRetainingWall, {
  HillsideRetainingWallData,
} from "./Pages/HillsideRetainingWall";
import FirePit, { FirePitData } from "./Pages/FirePit";
import BigDriveway, { BigDrivewayData } from "./Pages/BigDriveway";
import PermeablePavers, { PermeablePaversData } from "./Pages/PermeablePavers";
import PorcelainPavers, { PorcelainPaversData } from "./Pages/PorcelainPavers";
import PermeablePaverManufacturers, {
  PermeablePaverManufacturersData,
} from "./Pages/PermeablePaverManufacturers";
import DrivewayPatterns, {
  DrivewayPatternsData,
} from "./Pages/DrivewayPatterns";
import DoItYourself, { DoItYourselfData } from "./Pages/DoItYourself";
import RepairPaver, { RepairPaverData } from "./Pages/RepairPaver";
import HoaPaver from "./Pages/HoaPaver";
import DrivewayCost, { DrivewayCostData } from "./Pages/DrivewayCost";
import PaverWalkway, { PaverWalkwayData } from "./Pages/PaverWalkway";

const index = () => {
  return (
    <div className="container-fluid h-100">
      <Switch>
        <Route
          exact
          component={HowToChooseTheRightPaverColor}
          path="/blog/how-to-choose-the-right-paver-color"
        />
        <Route
          exact
          component={RemovingOilStains}
          path="/blog/removing-stains-pavers-oil-grease-hard-water-rust"
        />
        <Route
          exact
          component={InstallingPaversConcrete}
          path="/blog/installing-pavers-concrete-best-practices-potential-problems"
        />
        <Route
          exact
          component={JointSand}
          path="/blog/how-to-secure-joint-sand-between-pavers"
        />
        <Route
          exact
          component={Sealer}
          path="/blog/sealing-concrete-pavers-consider"
        />
        <Route
          exact
          component={KnowYourPaver}
          path="/blog/know-your-paver-well-permeable-vs-concrete-pavers"
        />
        <Route
          exact
          component={PatioEdging}
          path="/blog/best-way-edge-paver-patio-favorite-ideas"
        />
        <Route
          exact
          component={DrivewayComparing}
          path="/blog/driveway-paving-comparing-asphalt-vs-brick-vs-concrete"
        />
        <Route
          exact
          component={HillsideRetainingWall}
          path="/blog/constructing-hillside-retaining-walls-los-angeles-every-homeowner-needs-know"
        />
        <Route
          exact
          component={FirePit}
          path="/blog/everything-need-know-building-fire-pits-southern-california-backyard"
        />
        <Route
          exact
          component={BigDriveway}
          path="/blog/big-driveway-sizing-considerations-los-angeles-home"
        />
        <Route
          exact
          component={PermeablePavers}
          path="/blog/designing-a-permeable-paver-surface"
        />
        <Route
          exact
          component={PorcelainPavers}
          path="/blog/porcelain-pavers-beauty-durability-ease-maintenance"
        />
        <Route
          exact
          component={PermeablePaverManufacturers}
          path="/blog/favorite-permeable-paving-manufacturers-landscapes-streetscapes"
        />
        <Route
          exact
          component={DrivewayPatterns}
          path="/blog/3-favorite-driveway-brick-paving-patterns"
        />
        <Route
          exact
          component={DoItYourself}
          path="/blog/do-it-yourself-paver-installation"
        />
        <Route
          exact
          component={RepairPaver}
          path="/blog/repair-broken-driveway-paving-stone"
        />
        <Route
          exact
          component={HoaPaver}
          path="/blog/best-pavers-driveways-streets-sidewalks-homeowners-association"
        />
        <Route
          exact
          component={DrivewayCost}
          path="/blog/how-much-does-brick-driveway-paving-cost"
        />
        <Route
          exact
          component={PaverWalkway}
          path="/blog/14-paver-walkway-ideas"
        />
        {/* <Route exact component={PageNotFound} path="*" /> */}
        <Redirect from="/blog/*" to="/404" />
      </Switch>
    </div>
  );
};

export default withRouter(withMotion(index));

export const BLOG_DATA = [
  BigDrivewayData,
  DoItYourselfData,
  DrivewayComparingData,
  DrivewayCostData,
  DrivewayPatternsData,
  FirePitData,
  HillsideRetainingWallData,
  InstallingPaversConcreteData,
  JointSandData,
  KnowYourPaverData,
  PatioEdgingData,
  PaverWalkwayData,
  PermeablePaverManufacturersData,
  PermeablePaversData,
  PorcelainPaversData,
  RemovingOilStainsData,
  RepairPaverData,
  SealerData,
  HowToChooseTheRightPaverColorData
];
